import { Cookies } from 'react-cookie'
import { REFRESH_TOKEN_KEY } from 'src/constants'

const cookies = new Cookies()
const isLocalhost = window.location.hostname === 'localhost'

export const saveRefreshTokenToCookies = (RefreshToken: string | undefined) => {
  if (!RefreshToken) {
    return
  }

  const oneWeekFromNow = new Date()
  oneWeekFromNow.setDate(oneWeekFromNow.getDate() + 7)

  cookies.set(REFRESH_TOKEN_KEY, RefreshToken, {
    path: '/',
    domain: !isLocalhost ? '.gemvision.com' : 'localhost',
    expires: oneWeekFromNow,
    secure: !isLocalhost,
    sameSite: 'strict',
    httpOnly: false
  })
}

export const getRefreshTokenFromCookies = () => {
  const token = cookies.get(REFRESH_TOKEN_KEY)
  return token || null
}

export const deleteRefreshTokenFromCookies = () => {
  cookies.remove(REFRESH_TOKEN_KEY, {
    path: '/',
    domain: !isLocalhost ? '.gemvision.com' : 'localhost',
    secure: !isLocalhost
  })
}
